import React, { createContext, useContext, useState, useEffect } from 'react';
import { Platform } from 'react-native';

interface BeforeInstallPromptEvent extends Event {
  prompt: () => Promise<void>;
  userChoice: Promise<{ outcome: 'accepted' | 'dismissed' }>;
}

interface PwaContextProps {
  deferredPrompt: BeforeInstallPromptEvent | null;
  setDeferredPrompt: React.Dispatch<React.SetStateAction<BeforeInstallPromptEvent | null>>;
}

const PwaContext = createContext<PwaContextProps | undefined>(undefined);

export const usePwaContext = () => {
  const context = useContext(PwaContext);
  if (!context) {
    throw new Error('usePwaContext must be used within a PwaProvider');
  }
  return context;
};

export const PwaProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [deferredPrompt, setDeferredPrompt] = useState<BeforeInstallPromptEvent | null>(null);

  useEffect(() => {
    const handleBeforeInstallPrompt = (event: BeforeInstallPromptEvent) => {
      event.preventDefault();
      console.log('Deffering prompt!!!');
      setDeferredPrompt(event);
    };

    if (Platform.OS === 'web') {
      window?.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
    }

    return () => {
      if (Platform.OS === 'web') {
        window?.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
      }
    };
  }, []);

  return (
    <PwaContext.Provider value={{ deferredPrompt, setDeferredPrompt }}>
      {children}
    </PwaContext.Provider>
  );
};
